import Loadable from 'react-loadable'

const LOADABLE_CONFIG = { loading: () => null, delay: 500 }
export const DynamicPage = {
    loadPage(pageContainerName) {
        return Loadable({
          loader: () => import('../pages/DynamicPage'),
          loading: () => {
            window.currentPage = pageContainerName;
            return null
          }, 
          delay: 500 
         
        });
    }
}

export const Pages = {
    register: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../pages/RegisterPage'),
    }),
    demo: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../pages/DemoPage'),
    }),
    casino: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../pages/CasinoPage'),
    }),
    liveCasino: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../pages/LiveCasinoPage'),
    }),
    promotion: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../pages/PromotionPage'),
    }),
    forgots: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../pages/ForgotPage'),
    }),
    activationLink:  Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../pages/ActivationLinkPage'),
    }),
    error: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../pages/ErrorPage'),
    })
    ,
    testComp: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../pages/TestComponentPage'),
    }),
    leaderboardRedirection: Loadable({
      ...LOADABLE_CONFIG,
      loader: () =>
        import('../pages/LeaderboardRedirectionPage'),
    })
  }


// WEBPACK FOOTER //
// ./src/app/common/LinkRoutes.js